<template>
<div class="chapter">
<div class="inner_page">
<h2 class="chapter_title"><a id="page_264"></a><a id="ded"></a>DEDICATION</h2>
<p class="text_noindent">I wrote this book in honor of the family I grew up with—my great-grandparents, grandparents, uncles, aunts, mom, dad, and brother. And especially in memory of Octavio Rodriguez, Uncle Andy, and Aunt JoAnn.</p>
<p class="right">— JOSEF CENTENO</p>
<div class="wrap">
<p class="image"><img alt="image" class="vertical" src="images/f0264-01.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03dedication.vue?3751ac6b